var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-sheet',{staticClass:"rounded-xl policy pa-10 height-100x bordered"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.policyContent)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }